import React from "react";
import { useNavigate } from "react-router-dom";
import NavbarPixu from "../../components/Navbar"
import LandingPc from "../../assets/images/Pc_landing.png"
import { FaArrowRight } from "react-icons/fa6";
import FeaturesSection from "../../components/FeaturesSection"
import PricingSection from "../../components/PricingSection"
import AISection from "../../components/AiSection"
import WhyChooseUs from "../../components/Whychooseus"

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="text- block text-gray-900">
      <NavbarPixu />
      {/* Hero Section */}
      <section className="w-[60%] mx-auto text-center pt-10">
        <div className="w-[40%] mx-auto p-2 flex items-center justify-between  shadow-md mb-4 rounded-xl text-textTitle">
        <h4>Interesado? te hacemos una llamada ahora</h4>
        <FaArrowRight className=""/>
        </div>
        <h1 className="text-[56px] font-bold">AUTOMATIZANDO TU NEGOCIO USANDO IA CON PIXU</h1>
        <p className="mt-4 text-lg">Aumente sus ventas sin esfuerzo: experimente el poder de las automatizaciones de IA personalizadas, diseñadas especialmente para usted.</p>
        <button  onClick={() => navigate("/contact")} className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold">VAMOS A HABLAR</button>
      </section>

      <img className="w-[75%] mx-auto" src={LandingPc}></img>

      <FeaturesSection/>

      <PricingSection/>

      <AISection/>

      <WhyChooseUs/>


      {/* Footer */}
      <footer className="py-6 bg-bgSecundary text-white text-center">
        <p>&copy; 2025 PIXU. Todos los derechos reservados.</p>
        <div className="mt-2 flex justify-center space-x-4">
          <a href="#" className="hover:underline">Privacy</a>
          <a href="#" className="hover:underline">Contact Us</a>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
